import React from 'react'

function Checkbox({name,onChange,label,isRequired,id, checked, type }) {
  return (
    <div>
        <div className="flex items-start space-x-3 py-2">
            <input type={type} name={name} id={id} isRequired={isRequired} checked={checked} onChange={onChange}   className="border-gray-300 rounded h-5 w-5" />
            <div className="flex flex-col">
                <h1 className="text-[#FA6669] font-medium leading-none">{label}</h1>
                <p className="text-xs text-gray-500 mt-2 leading-4"></p>
             </div>
        </div>
    </div>
  )
}

export default Checkbox